import { globalEntitlements } from '../utils/globalEntitlements';

export const TRADEMARKS_SEARCH_CONFIG = {
  hero: {
    buyBox: [
      {
        bulletPoints: [
          { title: 'productPage.trademarksSearch.buyBox.bulletPoint1' },
          { title: 'productPage.trademarksSearch.buyBox.bulletPoint2' },
          { title: 'productPage.trademarksSearch.buyBox.bulletPoint3' },
        ],
        productName: 'productPage.trademarksSearch.buyBox.productName',
        veloCta: {
          displayVeloCta: true,
          promptMessageId: 'productPage.trademarksSearch.buyBox.veloCta.prompt',
          topic: 'trademark-search',
        },
        showPreviousPurchasedCallout: true,
        interactService: {
          ctaType: 'internalCheckout',
          service: 'trademarks_search',
        },
      },
    ],
    headerPicture: {
      src: '/s2/raster/laptop-studio-drawing.png',
      alt: 'productPage.trademarksSearch.heroPicture.altText',
    },
    headline: 'productPage.trademarksSearch.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.trademarksSearch.page.subheader',
  },
  expression: {
    title: 'productPage.trademarksSearch.sample.title',
    image: {
      src: '/s2/raster/trademark-results-sample-lg-v2.png',
      srcMobile: '/s2/raster/trademark-results-sample-xs.png',
      alt: 'productPage.trademarksSearch.sample.altText',
    },
    description: 'productPage.trademarksSearch.sample.description',
  },
  benefit: {
    title: 'productPage.trademarksSearch.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/searchrounded.svg',
        title: 'productPage.trademarksSearch.valueProp.propTitle1',
        description: 'productPage.trademarksSearch.valueProp.shortCopy1',
      },
      {
        icon: '/s2/material-icons/thumbuprounded.svg',
        title: 'productPage.trademarksSearch.valueProp.propTitle2',
        description: 'productPage.trademarksSearch.valueProp.shortCopy2',
      },
      {
        icon: '/s2/material-icons/hourglasstoprounded.svg',
        title: 'productPage.trademarksSearch.valueProp.propTitle3',
        description: 'productPage.trademarksSearch.valueProp.shortCopy3',
      },
      {
        icon: '/s2/material-icons/boltrounded.svg',
        title: 'productPage.trademarksSearch.valueProp.propTitle4',
        description: 'productPage.trademarksSearch.valueProp.shortCopy4',
      },
      {
        icon: '/s2/material-icons/lockrounded.svg',
        title: 'productPage.trademarksSearch.valueProp.propTitle5',
        description: 'productPage.trademarksSearch.valueProp.shortCopy5',
      },
      {
        icon: '/s2/material-icons/allinclusiverounded.svg',
        title: 'productPage.trademarksSearch.valueProp.propTitle6',
        description: 'productPage.trademarksSearch.valueProp.shortCopy6',
      },
    ],
  },
  faqs: {
    title: 'productPage.trademarksSearch.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.trademarksSearch.frequentlyAskedQuestions.faq1',
        answer: 'productPage.trademarksSearch.frequentlyAskedQuestions.faqAnswer1',
      },
      {
        question: 'productPage.trademarksSearch.frequentlyAskedQuestions.faq2',
        answer: 'productPage.trademarksSearch.frequentlyAskedQuestions.faqAnswer2',
      },
      {
        question: 'productPage.trademarksSearch.frequentlyAskedQuestions.faq3',
        answer: 'productPage.trademarksSearch.frequentlyAskedQuestions.faqAnswer3',
      },
      {
        question: 'productPage.trademarksSearch.frequentlyAskedQuestions.faq4',
        answer: 'productPage.trademarksSearch.frequentlyAskedQuestions.faqAnswer4',
      },
    ],
  },
  assistance: {
    title: 'productPage.trademarksSearch.needAssistance.title',
    getInTouch: 'productPage.trademarksSearch.needAssistance.getInTouch',
    actions: 'productPage.trademarksSearch.needAssistance.actions',
  },
  getBuyButtonConfig: globalEntitlements({
    ctaText: 'productPage.trademarksSearch.buyBox.buttonLabel',
    ownedCtaText: 'productPage.trademarksSearch.buyBox.buttonLabel.purchased',
  })
    .allowReviewPurchased()
    .build(),
};
